var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "#4F0259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4F0259",
    d: "M17.155 1.998l1.232 1.452a2.826 2.826 0 002.386.988l1.897-.156a2.826 2.826 0 013.048 3.048l-.156 1.897a2.826 2.826 0 00.988 2.386l1.452 1.232a2.826 2.826 0 010 4.31l-1.452 1.232a2.826 2.826 0 00-.988 2.386l.156 1.897a2.826 2.826 0 01-3.048 3.048l-1.897-.156a2.826 2.826 0 00-2.386.988l-1.232 1.452a2.826 2.826 0 01-4.31 0l-1.232-1.452a2.826 2.826 0 00-2.386-.988l-1.897.156a2.826 2.826 0 01-3.048-3.048l.156-1.897a2.826 2.826 0 00-.988-2.386l-1.452-1.232a2.826 2.826 0 010-4.31l1.452-1.232a2.826 2.826 0 00.988-2.386L4.282 7.33A2.826 2.826 0 017.33 4.282l1.897.156a2.826 2.826 0 002.386-.988l1.232-1.452a2.826 2.826 0 014.31 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 4,
    stroke: "#4F0259"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.9b9498a6d3f09e158502a0c33d04b98c.svg";
export { ForwardRef as ReactComponent };